// @ts-nocheck
import { Checkbox } from "@mui/material";
import PropTypes from "prop-types";
import { StyledTableCell } from "./SessionPositionEditableSheetTableCell";

export const SheetCheckBox = ({ value, onChange, onContextMenu }) => {
  const handleChange = (option) => {
    onChange(option);
  };

  return (
    <StyledTableCell onContextMenu={onContextMenu}>
      <Checkbox
        sx={{
          padding: "0",
          color: "white",
        }}
        checked={Boolean(value)}
        onChange={(e) => handleChange(e?.target?.checked)}
      />
    </StyledTableCell>
  );
};

SheetCheckBox.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onContextMenu: PropTypes.func,
};